import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faHistory, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ArticulosData.css';
import baseURL from '../../url';
import moneda from '../../moneda';

export default function ArticulosData() {
    const [articulos, setArticulos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalHistorialVisible, setModalHistorialVisible] = useState(false);
    const [articuloActual, setArticuloActual] = useState({});
    const [historial, setHistorial] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroCodigo, setFiltroCodigo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');

    // Campos del formulario
    const [codigo, setCodigo] = useState('');
    const [nombre, setNombre] = useState('');
    const [idCategoriaInventario, setIdCategoriaInventario] = useState('');
    const [idUnidadMedida, setIdUnidadMedida] = useState('');
    const [idProveedor, setIdProveedor] = useState('');
    const [cantidadStock, setCantidadStock] = useState('');
    const [cantidadAlerta, setCantidadAlerta] = useState('');
    const [precioCompraUnitario, setPrecioCompraUnitario] = useState('');
    const [precioCompraTotal, setPrecioCompraTotal] = useState('');
    const [precioVenta, setPrecioVenta] = useState('');

    useEffect(() => {
        cargarArticulos();
        cargarCategorias();
        cargarUnidades();
        cargarProveedores();
    }, []);

    const cargarArticulos = () => {
        fetch(`${baseURL}/inventarioArticulosGet.php`)
            .then(response => response.json())
            .then(data => {
                setArticulos(data.articulos || []);
            })
            .catch(error => console.error('Error al cargar artículos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/inventarioCategoriasGet.php`)
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarUnidades = () => {
        fetch(`${baseURL}/inventarioUnidadesGet.php`)
            .then(response => response.json())
            .then(data => setUnidades(data.unidades || []))
            .catch(error => console.error('Error al cargar unidades:', error));
    };

    const cargarProveedores = () => {
        fetch(`${baseURL}/inventarioProveedoresGet.php`)
            .then(response => response.json())
            .then(data => setProveedores(data.proveedores || []))
            .catch(error => console.error('Error al cargar proveedores:', error));
    };

    const abrirModalNuevo = () => {
        setArticuloActual({});
        limpiarFormulario();
        setModalVisible(true);
    };

    const abrirModalEditar = (articulo) => {
        setArticuloActual(articulo);
        setCodigo(articulo.codigo || '');
        setNombre(articulo.nombre || '');
        setIdCategoriaInventario(articulo.idCategoriaInventario || '');
        setIdUnidadMedida(articulo.idUnidadMedida || '');
        setIdProveedor(articulo.idProveedor || '');
        setCantidadStock(articulo.cantidadStock || '');
        setCantidadAlerta(articulo.cantidadAlerta || '');
        setPrecioCompraUnitario(articulo.precioCompraUnitario || '');
        setPrecioCompraTotal(articulo.precioCompraTotal || '');
        setPrecioVenta(articulo.precioVenta || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        limpiarFormulario();
    };

    const limpiarFormulario = () => {
        setCodigo('');
        setNombre('');
        setIdCategoriaInventario('');
        setIdUnidadMedida('');
        setIdProveedor('');
        setCantidadStock('');
        setCantidadAlerta('');
        setPrecioCompraUnitario('');
        setPrecioCompraTotal('');
        setPrecioVenta('');
    };

    const guardarArticulo = () => {
        if (!nombre || !idUnidadMedida) {
            toast.error('El nombre y la unidad de medida son obligatorios');
            return;
        }

        const formData = new FormData();
        formData.append('codigo', codigo);
        formData.append('nombre', nombre);
        formData.append('idCategoriaInventario', idCategoriaInventario);
        formData.append('idUnidadMedida', idUnidadMedida);
        formData.append('idProveedor', idProveedor);
        formData.append('cantidadStock', cantidadStock);
        formData.append('cantidadAlerta', cantidadAlerta);
        formData.append('precioCompraUnitario', precioCompraUnitario);
        formData.append('precioCompraTotal', precioCompraTotal);
        formData.append('precioVenta', precioVenta);

        if (articuloActual.idArticulo) {
            // Editar
            const payload = {
                codigo, nombre, idCategoriaInventario, idUnidadMedida, idProveedor,
                cantidadStock, cantidadAlerta, precioCompraUnitario, precioCompraTotal, precioVenta
            };

            fetch(`${baseURL}/inventarioArticulosPut.php?idArticulo=${articuloActual.idArticulo}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarArticulos();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            fetch(`${baseURL}/inventarioArticulosPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarArticulos();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarArticulo = (idArticulo) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/inventarioArticulosDelete.php?idArticulo=${idArticulo}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarArticulos();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const verHistorial = (idArticulo) => {
        fetch(`${baseURL}/inventarioArticulosHistorial.php?idArticulo=${idArticulo}`)
            .then(response => response.json())
            .then(data => {
                setHistorial(data.historial || []);
                setModalHistorialVisible(true);
            })
            .catch(error => toast.error(error.message));
    };

    const articulosFiltrados = articulos.filter(item => {
        const nombreMatch = item.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
        const codigoMatch = !filtroCodigo || (item.codigo && item.codigo.includes(filtroCodigo));
        const categoriaMatch = !filtroCategoria || item.idCategoriaInventario == filtroCategoria;
        return nombreMatch && codigoMatch && categoriaMatch;
    });

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Artículo
                </button>

                <div className='gastosFiltros'>
                    <input
                        type="text"
                        placeholder="Buscar por nombre"
                        value={filtroNombre}
                        onChange={(e) => setFiltroNombre(e.target.value)}
                        className='filtroInput'
                    />
                    <input
                        type="text"
                        placeholder="Buscar por código"
                        value={filtroCodigo}
                        onChange={(e) => setFiltroCodigo(e.target.value)}
                        className='filtroInput'
                    />
                    <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)} className='filtroInput'>
                        <option value="">Todas las categorías</option>
                        {categorias.map(cat => (
                            <option key={cat.idCategoriaInventario} value={cat.idCategoriaInventario}>
                                {cat.nombre}
                            </option>
                        ))}
                    </select>
                    
                </div>
            </div>

            {/* Modal Formulario */}
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{articuloActual.idArticulo ? 'Editar Artículo' : 'Nuevo Artículo'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <div className='flexGrap'>
                            <fieldset>
                                <legend>Código</legend>
                                <input type="text" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Nombre *</legend>
                                <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Categoría</legend>
                                <select value={idCategoriaInventario} onChange={(e) => setIdCategoriaInventario(e.target.value)}>
                                    <option value="">Seleccione</option>
                                    {categorias.map(cat => (
                                        <option key={cat.idCategoriaInventario} value={cat.idCategoriaInventario}>
                                            {cat.nombre}
                                        </option>
                                    ))}
                                </select>
                            </fieldset>
                            <fieldset>
                                <legend>Unidad de Medida *</legend>
                                <select value={idUnidadMedida} onChange={(e) => setIdUnidadMedida(e.target.value)}>
                                    <option value="">Seleccione</option>
                                    {unidades.map(uni => (
                                        <option key={uni.idUnidadMedida} value={uni.idUnidadMedida}>
                                            {uni.nombre} ({uni.simbolo})
                                        </option>
                                    ))}
                                </select>
                            </fieldset>
                            <fieldset>
                                <legend>Proveedor</legend>
                                <select value={idProveedor} onChange={(e) => setIdProveedor(e.target.value)}>
                                    <option value="">Seleccione</option>
                                    {proveedores.map(prov => (
                                        <option key={prov.idProveedor} value={prov.idProveedor}>
                                            {prov.nombre}
                                        </option>
                                    ))}
                                </select>
                            </fieldset>
                            <fieldset>
                                <legend>Cantidad en Stock</legend>
                                <input type="number" step="0.01" value={cantidadStock} onChange={(e) => setCantidadStock(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Cantidad de Alerta</legend>
                                <input type="number" step="0.01" value={cantidadAlerta} onChange={(e) => setCantidadAlerta(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Precio Compra Unitario</legend>
                                <input type="number" step="0.01" value={precioCompraUnitario} onChange={(e) => setPrecioCompraUnitario(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Precio Compra Total</legend>
                                <input type="number" step="0.01" value={precioCompraTotal} onChange={(e) => setPrecioCompraTotal(e.target.value)} />
                            </fieldset>
                            <fieldset>
                                <legend>Precio de Venta</legend>
                                <input type="number" step="0.01" value={precioVenta} onChange={(e) => setPrecioVenta(e.target.value)} />
                            </fieldset>
                        </div>

                        <button className='btnPost' onClick={guardarArticulo}>Guardar</button>
                    </div>
                </div>
            )}

            {/* Modal Historial */}
            {modalHistorialVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>Historial de Cambios</h3>
                            <span className="close" onClick={() => setModalHistorialVisible(false)}>&times;</span>
                        </div>

                        <div className='table-container'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Campo</th>
                                        <th>Valor Anterior</th>
                                        <th>Valor Nuevo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historial.map((item, index) => (
                                        <tr key={index}>
                                            <td>{new Date(item.fechaCambio).toLocaleString()}</td>
                                            <td>{item.campo}</td>
                                            <td>{item.valorAnterior}</td>
                                            <td>{item.valorNuevo}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* Tabla de Artículos */}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Artículo</th>
                            <th>Categoría</th>
                            <th>Proveedor</th>
                            <th>Unidad</th>
                            <th>Stock</th>
                            <th>Precio Compra</th>
                            <th>Precio Venta</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {articulosFiltrados.map(item => (
                            <tr key={item.idArticulo} style={{
                                backgroundColor: item.cantidadStock <= item.cantidadAlerta ? '#ffebee' : 'transparent'
                            }}>
                                <td>{item.codigo}</td>
                                <td>{item.nombre}</td>
                                <td>{item.nombreCategoria || '-'}</td>
                                <td>{item.nombreProveedor || '-'}</td>
                                <td>{item.simboloUnidad}</td>
                                <td>{item.cantidadStock}</td>
                                <td style={{ color: '#008000' }}>
                                    {moneda} {`${item.precioCompraUnitario}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>
                                <td style={{ color: '#008000' }}>
                                    {moneda} {`${item.precioVenta}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>
                                <td>
                                    <button className='editar' onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <button className='duplicar' onClick={() => verHistorial(item.idArticulo)}>
                                        <FontAwesomeIcon icon={faHistory} />
                                    </button>
                                    <button className='eliminar' onClick={() => eliminarArticulo(item.idArticulo)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}


